import { Ionicons } from '@expo/vector-icons';
import React from 'react';
import { Pressable, ScrollView, View } from 'react-native';

import { ThemedText } from '@/components/themed-text';
import { DiscoveryCategory } from '@/types/discovery';
import { cn } from '@/utils/cn';
import { useThemedHex } from '@/hooks/use-theme-colors';

type CategoryChipsProps = {
  categories: DiscoveryCategory[];
  selected: string[];
  onToggle: (slug: string) => void;
};

/** Chips de categoria do catálogo. Multisseleção: "beleza + pets" é uma busca legítima. */
export function CategoryChips({ categories, selected, onToggle }: CategoryChipsProps) {
  const th = useThemedHex();
  if (categories.length === 0) return null;

  return (
    <ScrollView
      keyboardShouldPersistTaps="handled"
      horizontal
      showsHorizontalScrollIndicator={false}
      contentContainerStyle={{ gap: 8, paddingHorizontal: 20 }}
    >
      {categories.map((category) => {
        const isSelected = selected.includes(category.slug);

        return (
          <Pressable
            key={category.slug}
            onPress={() => onToggle(category.slug)}
            className={cn(
              'flex-row items-center gap-1.5 rounded-full border px-3 py-1.5',
              isSelected ? 'border-primary bg-primary-50' : 'border-neutral-900/5 bg-neutral-50',
            )}
          >
            {category.icon ? (
              <Ionicons
                name={category.icon as never}
                size={13}
                color={isSelected ? '#FD5001' : th('#737373')}
              />
            ) : null}

            <ThemedText
              className={cn(
                'text-xs',
                isSelected ? 'font-semibold text-primary' : 'text-neutral-600',
              )}
            >
              {category.label}
            </ThemedText>
          </Pressable>
        );
      })}

      <View className="w-1" />
    </ScrollView>
  );
}
